import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import axios from "axios";

// helpers/services


// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import { Label, FormGroup } from "reactstrap";
import Datetime from "react-datetime";

// core components
import Grid from "components/Grid/GridContainer";
import Col from "components/Grid/GridItem";
import TSText from "components/Forms/TSText";
import TSSelect2 from "components/Forms/TSSelect2";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import { Collapse, Modal, ModalBody, ModalHeader, ModalFooter } from "reactstrap";

import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TableSortLabel,
    TableFooter,
    TablePagination,
} from '@material-ui/core';

import "react-datetime/css/react-datetime.css";
import "./custom-style.css";

// -------------------- Styles --------------------
const styles = {
    cardCategoryWhite: {
        color: "rgba(255,255,255,.62)",
        margin: 0,
        fontSize: "14px",
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: 0,
        minHeight: "auto",
        fontWeight: 300,
        fontFamily: '"Sarabun", sans-serif',
        marginBottom: "3px",
        textDecoration: "none",
    },
    tableRow: {
        '&:hover': {
            backgroundColor: '#f5f5f5 !important',
        }
    }
};
const useStyles = makeStyles(styles);

// -------------------- Component --------------------
const ESignList = (props) => {
    const classes = useStyles();
    const history = useHistory();
    // const user = useSelector((state) => state.auth.user); 

    const location = props.location; // หรือใช้ useLocation() ก็ได้
    const savedState = location.state?.savedFilters;

    const moment = require("moment");
    require("moment/locale/th");

    //const [docDT, setDocDT] = useState(moment().format("YYYY-MM-DD"));
    //const [keyword, setKeyword] = useState("");
    //const [keywordInput, setKeywordInput] = useState("");
    //const [serviceUnitKey, setServiceUnitKey] = useState(161);

    const [docDT, setDocDT] = useState(() => {
        // ถ้ามีค่าส่งกลับมา ให้ใช้ค่าเดิม / ถ้าไม่มี ใช้วันปัจจุบัน
        return savedState?.docDT || moment().format("YYYY-MM-DD");
    });

    const [keyword, setKeyword] = useState(() => {
        return savedState?.keyword || "";
    });

    // keywordInput ต้องแก้ด้วย ไม่งั้นค่าใน State เปลี่ยน แต่ในกล่องข้อความว่างเปล่า
    const [keywordInput, setKeywordInput] = useState(() => {
        return savedState?.keyword || "";
    });

    const [serviceUnitKey, setServiceUnitKey] = useState(() => {
        return savedState?.serviceUnitKey || 161;
    });


    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    // Lookups
    const [ArrServiceUnit, setArrServiceUnit] = useState([]);

    // UI State
    const [isShowList, setIsShowList] = useState(true);
    const [dateFocus, setDateFocus] = useState(false);
    const [reloadTrigger, setReloadTrigger] = useState(false); // สำหรับ Force Reload

    // Table State
    const [dataList, setDataList] = useState([]);
    const [orderDirection, setOrderDirection] = useState('desc');
    const [orderBy, setOrderBy] = useState('hn');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(100);

    // --- Template Modal ---
    const [modalTemplates, setModalTemplates] = useState(false);
    const [selectedVisitForModal, setSelectedVisitForModal] = useState(null);

    // --- Delete Modal State ---
    const [modalDelete, setModalDelete] = useState(false);
    const [itemToDelete, setItemToDelete] = useState(null); // เก็บ template object ที่จะลบ
    const [isDeleting, setIsDeleting] = useState(false);


    // 3. ฝังความทรงจำทุกครั้งที่ Filter เปลี่ยน (สำคัญมาก!)
    useEffect(() => {
        history.replace({
            pathname: location.pathname,
            search: location.search,
            state: {
                ...location.state,
                savedFilters: { // เก็บใส่กล่องชื่อ savedFilters
                    docDT,
                    keyword,
                    serviceUnitKey
                }
            }
        });
    }, [docDT, keyword, serviceUnitKey]);

    // -------------------- Fetch Data --------------------
    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                setError(null);

                const response = await axios.get("/api/v1/reportview/esignlist", {
                    params: {
                        docDT: docDT || undefined,
                        keyword: keyword || undefined,
                        serviceUnitKey: serviceUnitKey || undefined
                    },
                });

                const _data = response.data?.data || [];
                setDataList(_data);

                if (_data && _data.length > 0) {
                    const unique = [
                        ...new Map(
                            _data.map(item => [item.visit.serviceUnitKey, {
                                ServiceUnitKey: item.visit.serviceUnitKey,
                                ServiceUnitName: item.visit.serviceUnitName,
                                value: item.visit.serviceUnitKey,
                                label: item.visit.serviceUnitName,
                            }])
                        ).values()
                    ];
                    setArrServiceUnit(unique);
                }

            } catch (err) {
                console.error(err);
                setError(err.message || "Error");
            } finally {
                setLoading(false);
            }
        };

        if (!docDT || docDT.trim() === "") return;
        fetchData();
    }, [docDT, keyword, serviceUnitKey, reloadTrigger]); // เพิ่ม reloadTrigger

    // -------------------- Sorting Logic --------------------
    const handleRequestSort = (property) => {
        const isAsc = orderBy === property && orderDirection === 'asc';
        setOrderDirection(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const sortedData = () => {
        return dataList.sort((a, b) => {
            let valA = a.visit[orderBy] || '';
            let valB = b.visit[orderBy] || '';

            if (typeof valA === 'string') valA = valA.toLowerCase();
            if (typeof valB === 'string') valB = valB.toLowerCase();

            if (orderDirection === 'asc') {
                return valA < valB ? -1 : 1;
            }
            return valA > valB ? -1 : 1;
        });
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    // -------------------- Action Handlers --------------------

    const handleGoToSign = (visitData, templateData) => {
        const payload = {
            referenceKey: visitData.referenceKey,
            tableName: visitData.tableName,
            referenceName: visitData.referenceName,
            clinicVisitKey: visitData.clinicVisitKey,
            templateId: templateData.templateId,
            rdlcPath: templateData.rdlcPath,
            docName: templateData.name,
            patientName: visitData.fullName,
            hn: visitData.hn        
        };

        setModalTemplates(false);
        history.push({
            pathname: "/consent/sign",
            state: payload
        });
    };

    const handleSignClick = (row) => {
        const templates = row.templates || [];
        if (templates.length === 0) {
            alert("ไม่พบ Template เอกสาร");
            return;
        }
        if (templates.length === 1) {
            handleGoToSign(row.visit, templates[0]);
        } else {
            setSelectedVisitForModal(row);
            setModalTemplates(true);
        }
    };

    // --- Delete Logic ---
    const handleClickDelete = (templateData) => {
        setItemToDelete(templateData);
        setModalDelete(true);
    };

    const confirmDelete = async () => {
        if (!itemToDelete) return;
        setIsDeleting(true);
        try {
            // เรียก API Delete
            await axios.delete(`/api/v1/reportview/esign/${itemToDelete.reportId}`);

            // ปิด Modal
            setModalDelete(false);
            setModalTemplates(false); // ปิดหน้าเลือก template ด้วย (ถ้าเปิดอยู่)

            // Refresh ข้อมูล
            setReloadTrigger(!reloadTrigger);

        } catch (err) {
            console.error(err);
            alert("เกิดข้อผิดพลาดในการลบ: " + (err.message || "Unknown error"));
        } finally {
            setIsDeleting(false);
            setItemToDelete(null);
        }
    };

    // -------------------- Render Helpers --------------------

    // 1. ส่วนแสดงสถานะ (ปุ่มเซ็น หรือ ปุ่มดูเอกสาร)
    const renderStatusCell = (row) => {
        const templates = row.templates || [];
        const allSigned = templates.length > 0 && templates.every(t => t.isSigned === true);

        if (allSigned) {
            // กรณีเซ็นครบแล้ว
            if (templates.length === 1) {
                // มีใบเดียว -> ลิงก์เปิด PDF
                const temp = templates[0];
                return (
                    <a
                        href={`/pdf/report/${temp.reportId}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ textDecoration: 'none', cursor: 'pointer' }}
                        title="ดูเอกสาร"
                    >
                        <i className="fas fa-check-circle" style={{ color: "green", fontSize: "1.5em" }}></i>
                    </a>
                );
            } else {
                // มีหลายใบ -> ไอคอนกดเปิด Modal
                return (
                    <span
                        style={{ cursor: 'pointer' }}
                        onClick={() => {
                            setSelectedVisitForModal(row);
                            setModalTemplates(true);
                        }}
                    >
                        <i className="fas fa-check-circle" style={{ color: "green", fontSize: "1.5em" }} title="ครบถ้วน (คลิกเพื่อดูรายละเอียด)"></i>
                    </span>
                );
            }
        } else {
            // กรณีรอเซ็น -> ปุ่มลงนาม
            if (templates.length === 0) return null;
            return (
                <div style={{ textAlign: 'center' }}>
                    <Button
                        color="warning"
                        size="sm"
                        onClick={() => handleSignClick(row)}
                        title="ลงนามเอกสาร"
                        style={{ padding: '0.2rem 0.5rem', fontSize: '0.8rem' }}
                    >
                        <i className="fas fa-file-signature"></i> ลงนาม
                    </Button>
                    {templates.length > 1 && (
                        <div style={{ fontSize: '0.7em', color: '#666', marginTop: '2px' }}>
                            {templates.filter(t => t.isSigned).length} / {templates.length}
                        </div>
                    )}
                </div>
            );
        }
    };

    // 2. ส่วนแสดงปุ่มลบ (แยกออกมาต่างหาก)
    const renderDeleteCell = (row) => {
        const templates = row.templates || [];
        const allSigned = templates.length > 0 && templates.every(t => t.isSigned === true);

        // แสดงปุ่มลบเฉพาะเมื่อ: มี 1 ใบ และ เซ็นแล้ว
        // (ถ้ามีหลายใบ ต้องเข้าไปลบใน Modal เพื่อความปลอดภัยและไม่สับสน)
        if (templates.length === 1 && allSigned) {
            const temp = templates[0];
            return (
                <Button
                    color="danger"
                    size="sm"
                    justIcon
                    onClick={() => handleClickDelete(temp)}
                    title="ลบข้อมูลการเซ็น"
                    style={{ padding: '0.2rem 0.5rem' }}
                >
                    <i className="fas fa-trash"></i>
                </Button>
            );
        }
        return null; // ถ้ายังไม่เซ็น หรือมีหลายใบ ไม่แสดงปุ่มลบในหน้านี้
    };
    // -------------------- Render Main --------------------
    return (
        <div>
            <Grid>
                <Col xs={12} sm={12} md={12} style={{ display: isShowList ? 'block' : 'none' }}>
                    <Card>
                        <CardHeader color="primary">
                            <h4 className={classes.cardTitleWhite}>รายการหัตถการ (E-Sign)</h4>
                        </CardHeader>
                        <CardBody>
                            <div>
                                <Grid>
                                    {/* --- Search Filters --- */}
                                    <Col xs={12} sm={4} md={4}>
                                        <Label>วันที่รับบริการ</Label>
                                        <FormGroup className={"input-lg" + (dateFocus ? " input-group-focus" : "")}>
                                            <i className="far fa-calendar-check fa-2x" style={{ position: 'absolute', left: '30px', zIndex: 1 }} ></i>
                                            <Datetime
                                                value={moment(docDT).isValid() ? moment(docDT) : null}
                                                renderYear={(props, year) => <td {...props}>{year + 543}</td>}
                                                inputProps={{
                                                    name: "docDT", placeholder: "วันที่รับบริการ", readOnly: 'readonly',
                                                    style: { fontSize: '1.2em', borderRadius: 0, paddingLeft: '50px', cursor: 'pointer', background: '#ffffff', color: '#000000' }
                                                }}
                                                closeOnSelect={true}
                                                dateFormat="D MMMM BBBB" timeFormat={false}
                                                onFocus={() => setDateFocus(true)}
                                                onBlur={() => setDateFocus(false)}
                                                onChange={e => setDocDT(e.format('YYYY-MM-DD'))}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col xs={12} sm={4} md={4}>
                                        <TSText icon="far fa-edit" label="คำค้นหา" value={keywordInput} placeholder={"ค้นหา 3 ตัวอักษรขึ้นไป"}
                                            onChange={e => {
                                                const v = e.target.value;
                                                setKeywordInput(v);
                                                if (v === "" || v.length >= 3) setKeyword(v);
                                            }}
                                        />
                                    </Col>
                                    <Col xs={12} sm={4} md={4}>
                                        <TSSelect2 isClearable={true} label="หน่วยบริการ" options={ArrServiceUnit} value={serviceUnitKey} onChange={e => setServiceUnitKey(e != null ? e.value : '')} />
                                    </Col>
                                </Grid>

                                {/* --- Table --- */}
                                <TableContainer component={Paper}>
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>
                                                    <TableSortLabel active={orderBy === 'hn'} direction={orderBy === 'hn' ? orderDirection : 'asc'} onClick={() => handleRequestSort('hn')}>
                                                        HN
                                                    </TableSortLabel>
                                                </TableCell>
                                                <TableCell>
                                                    <TableSortLabel active={orderBy === 'fullName'} direction={orderBy === 'fullName' ? orderDirection : 'asc'} onClick={() => handleRequestSort('fullName')}>
                                                        ชื่อ-สกุล
                                                    </TableSortLabel>
                                                </TableCell>
                                                <TableCell>หัตถการ</TableCell>
                                                <TableCell style={{ display: (serviceUnitKey == 0 ? 'table-cell' : 'none') }}>
                                                    <TableSortLabel active={orderBy === 'serviceUnitName'} direction={orderBy === 'serviceUnitName' ? orderDirection : 'asc'} onClick={() => handleRequestSort('serviceUnitName')}>
                                                        หน่วยบริการ
                                                    </TableSortLabel>
                                                </TableCell>
                                                <TableCell align="center" style={{ width: '150px' }}>
                                                    สถานะ/จัดการ
                                                </TableCell>
                                                <TableCell align="center" style={{ width: '150px' }}>
                                                    ลบ
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {sortedData()
                                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                .map((row, index) => {
                                                    const rowIndex = page * rowsPerPage + index;
                                                    const visit = row.visit;
                                                    return (
                                                        <TableRow key={index} className={classes.tableRow} style={{ backgroundColor: rowIndex % 2 === 0 ? '#f9f9f9' : '#ffffff' }}>
                                                            <TableCell>{visit.hn}</TableCell>
                                                            <TableCell>{visit.fullName}</TableCell>
                                                            <TableCell>{visit.itemName}</TableCell>
                                                            <TableCell style={{ display: serviceUnitKey == 0 ? '' : 'none' }}>
                                                                {visit.serviceUnitName}
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {renderStatusCell(row)}
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {renderDeleteCell(row)}
                                                            </TableCell>
                                                        </TableRow>
                                                    );
                                                })}
                                            {dataList.length === 0 && !loading && (
                                                <TableRow>
                                                    <TableCell colSpan={5} align="center" style={{ height: '100px' }}>
                                                        ไม่พบข้อมูล
                                                    </TableCell>
                                                </TableRow>
                                            )}
                                        </TableBody>
                                        <TableFooter>
                                            <TableRow>
                                                <TablePagination
                                                    rowsPerPageOptions={[20, 50, 100]}
                                                    count={dataList.length}
                                                    rowsPerPage={rowsPerPage}
                                                    page={page}
                                                    onPageChange={handleChangePage}
                                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                                />
                                            </TableRow>
                                        </TableFooter>
                                    </Table>
                                </TableContainer>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
            </Grid>

            {/* --- Modal: เลือก Template / จัดการไฟล์ (กรณีมีหลายใบ หรือ กดดูรายละเอียด) --- */}
            <Modal isOpen={modalTemplates} toggle={() => setModalTemplates(!modalTemplates)} size="lg">
                <ModalHeader toggle={() => setModalTemplates(false)}>
                    รายการเอกสาร
                </ModalHeader>
                <ModalBody>
                    {selectedVisitForModal && (
                        <div>
                            <h5 style={{ marginBottom: '15px' }}>
                                ผู้ป่วย: {selectedVisitForModal.visit.fullName} (HN: {selectedVisitForModal.visit.hn})
                            </h5>
                            <TableContainer component={Paper} style={{ boxShadow: 'none', border: '1px solid #ddd' }}>
                                <Table size="small">
                                    <TableHead>
                                        <TableRow style={{ backgroundColor: '#f1f1f1' }}>
                                            <TableCell>ชื่อเอกสาร</TableCell>
                                            <TableCell align="center">สถานะ</TableCell>
                                            <TableCell align="center">ดำเนินการ</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {selectedVisitForModal.templates.map((temp, i) => (
                                            <TableRow key={i}>
                                                <TableCell>{temp.name}</TableCell>
                                                <TableCell align="center">
                                                    {temp.isSigned ? (
                                                        <span style={{ color: 'green', fontWeight: 'bold' }}>
                                                            <i className="fas fa-check"></i> ลงนามแล้ว
                                                        </span>
                                                    ) : (
                                                        <span style={{ color: 'orange' }}>รอลงนาม</span>
                                                    )}
                                                </TableCell>
                                                <TableCell align="center">
                                                    {/* ถ้าเซ็นแล้ว แสดงปุ่มดู และ ปุ่มลบ */}
                                                    {temp.isSigned ? (
                                                        <div>
                                                            <a
                                                                href={`/pdf/report/${temp.reportId}`}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                className="btn btn-info btn-sm"
                                                                style={{ marginRight: '5px', color: 'white' }}
                                                            >
                                                                <i className="fas fa-eye"></i> ดู
                                                            </a>
                                                            <Button
                                                                color="danger"
                                                                size="sm"
                                                                onClick={() => handleClickDelete(temp)}
                                                            >
                                                                <i className="fas fa-trash"></i> ลบ
                                                            </Button>
                                                        </div>
                                                    ) : (
                                                        // ถ้ายังไม่เซ็น แสดงปุ่มเลือก
                                                        <Button
                                                            color="info"
                                                            size="sm"
                                                            onClick={() => handleGoToSign(selectedVisitForModal.visit, temp)}
                                                        >
                                                            เลือก
                                                        </Button>
                                                    )}
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </div>
                    )}
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={() => setModalTemplates(false)}>ปิดหน้าต่าง</Button>
                </ModalFooter>
            </Modal>

            {/* --- Modal: ยืนยันการลบ (Delete Confirmation) --- */}
            <Modal isOpen={modalDelete} toggle={() => setModalDelete(!modalDelete)}>
                <div className="modal-header justify-content-center">
                    <div style={{ textAlign: 'center' }}>
                        <i className="fa fa-exclamation-triangle" style={{ color: "orange", fontSize: "3em" }}></i>
                        <h4 style={{ marginTop: '10px' }}>ยืนยันการลบข้อมูล</h4>
                    </div>
                </div>
                <ModalBody>
                    <div style={{ textAlign: "center", fontSize: "1.1em" }}>
                        <p>คุณต้องการลบข้อมูลการลงนามใบยินยอมนี้ใช่หรือไม่?</p>
                        {itemToDelete && (
                            <p style={{ color: '#666', fontSize: '0.9em' }}>
                                เอกสาร: {itemToDelete.name} <br />
                                (Report ID: {itemToDelete.reportId})
                            </p>
                        )}
                        {isDeleting && <p style={{ color: 'blue' }}>กำลังดำเนินการ...</p>}
                    </div>
                </ModalBody>
                <div className="modal-footer justify-content-center">
                    <Button
                        color="danger"
                        onClick={confirmDelete}
                        disabled={isDeleting}
                        style={{ marginRight: '10px' }}
                    >
                        <i className="fa fa-trash"></i> ยืนยันลบ
                    </Button>
                    <Button
                        color="secondary"
                        onClick={() => setModalDelete(false)}
                        disabled={isDeleting}
                    >
                        ยกเลิก
                    </Button>
                </div>
            </Modal>

        </div>
    );
};

export default ESignList;